export default __webpack_public_path__ + "static/media/nave-reuveni.8c4eda11.png";